import React from "react";
import { Quote } from "lucide-react";
import { GOOGLE_REVIEWS } from "../data/content";
import { GoogleG } from "./GoogleReviewBadge";

const slug = (n) => n.toLowerCase().replace(/\s+/g, "-");

export const TestimonialCard = ({ t, index }) => (
  <figure
    className="break-inside-avoid mb-5 bg-white border border-[#E5E7EB] rounded-2xl p-7 lg:p-8 flex flex-col hover:border-[#0066FF]/40 hover:-translate-y-0.5 transition-[transform,border-color] duration-300 animate-fade-up"
    style={{ animationDelay: `${index * 80}ms` }}
    data-testid={`testimonial-card-${slug(t.name)}`}
  >
    <div className="flex items-center justify-between">
      <div className="flex text-[#F59E0B] text-lg leading-none" aria-label={`${t.stars} out of 5 stars`}>
        {Array.from({ length: t.stars }).map((_, j) => (<span key={j}>★</span>))}
      </div>
      <Quote className="w-6 h-6 text-[#0066FF] opacity-30" aria-hidden="true" />
    </div>
    <blockquote className="mt-5 text-[#374151] leading-relaxed text-[15px] lg:text-base">
      <p>&ldquo;{t.quote}&rdquo;</p>
    </blockquote>
    <figcaption className="mt-6 pt-5 border-t border-[#F3F4F6] flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-[#0A2540] text-white flex items-center justify-center text-sm font-semibold" aria-hidden="true">
          {t.name.charAt(0)}
        </div>
        <div className="font-medium text-[#0A2540] text-sm" data-testid={`testimonial-name-${slug(t.name)}`}>{t.name}</div>
      </div>
      <a
        href={GOOGLE_REVIEWS.url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-xs text-[#6B7280] hover:text-[#0066FF] transition-colors"
        data-testid={`testimonial-source-${slug(t.name)}`}
      >
        <GoogleG size={14} /> Google review
      </a>
    </figcaption>
  </figure>
);
